import { removeEmptyEntries } from '../..';
import tracker from '../TrackingService';
import { getBQClickFields } from '../reportEvent';

export const reportSeeMoreEvent = (type, eventData = {}) => {
    tracker.sendBQEvent(
        getBQClickFields({
            type: type.BigQuery,
            elementName: 'see_more',
            componentName: 'review',
        })
    );

    const { pageName, itemsCount, gigId, studioId, sellerId, filterType } = eventData;
    tracker.sendMixPanelEvent({
        eventName: type.Mixpanel,
        eventPayload: removeEmptyEntries({
            'Page Name': pageName,
            'Items Count': itemsCount,
            'Gig Id': gigId,
            'Studio Id': studioId,
            'Seller Id': sellerId,
            'Filter Type': filterType,
        }),
    });
};

export const Events = {
    seeMore: {
        BigQuery: 'clicked_on_show_more',
        Mixpanel: 'Clicked on Reviews See More',
    },
};
